<p-toast></p-toast>

<div class="auth-container-login">
  <!-- Left Side - Background Image -->
  <div class="auth-left">
    <img src="assets/layout/images/bgimage.png" alt="Background" class="background-image">
    <div class="background-overlay">
      <div class="welcome-content">
        <h1>Reset Password</h1>
        <p>Create a new secure password</p>
      </div>
    </div>
  </div>

  <!-- Right Side - Reset Password Form -->
  <div class="auth-right">
    <div class="form-container">
      <div class="logo-section">
        <div class="logo-row">
          <img src="assets/layout/images/wow-care-logo-new.png" alt="WowCare Logo" class="logo">
          <span class="brand-text">WowCare</span>
        </div>
        <h3>Reset Password</h3>
      </div>

      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="form-group">
          <label for="password" class="form-label">New Password</label>
          <div class="input-wrapper">
            <i class="pi pi-lock input-icon"></i>
            <input
              [type]="passwordVisible ? 'text' : 'password'"
              id="password"
              formControlName="password"
              placeholder="Enter new password"
              class="form-input"
            />
            <i
              class="pi eye-icon"
              [ngClass]="passwordVisible ? 'pi-eye-slash' : 'pi-eye'"
              (click)="togglePasswordVisibility()"
            ></i>
          </div>
          <!-- Password Strength Indicator -->
          <div *ngIf="resetForm.get('password')?.value && passwordStrength.feedback" class="password-strength">
            <div class="strength-bar">
              <div
                class="strength-fill"
                [style.width.%]="(passwordStrength.score / 6) * 100"
                [style.background-color]="passwordStrength.color"
              ></div>
            </div>
            <span class="strength-text" [style.color]="passwordStrength.color">
              {{ passwordStrength.feedback }}
            </span>
          </div>
          <small *ngIf="resetForm.get('password')?.invalid && resetForm.get('password')?.touched" class="error-text">
            Password must be at least 5 characters
          </small>
        </div>

        <div class="form-group">
          <label for="confirmPassword" class="form-label">Confirm Password</label>
          <div class="input-wrapper">
            <i class="pi pi-lock input-icon"></i>
            <input
              [type]="confirmPasswordVisible ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword"
              placeholder="Confirm new password"
              class="form-input"
            />
            <i
              class="pi eye-icon"
              [ngClass]="confirmPasswordVisible ? 'pi-eye-slash' : 'pi-eye'"
              (click)="toggleConfirmPasswordVisibility()"
            ></i>
          </div>
          <small *ngIf="resetForm.get('confirmPassword')?.errors?.['mismatch'] && resetForm.get('confirmPassword')?.touched" class="error-text">
            Passwords do not match
          </small>
        </div>

        <div class="form-actions">
          <button
            pButton
            type="submit"
            label="Reset Password"
            [loading]="loading"
            class="auth-button"
            [disabled]="resetForm.invalid || !token"
          ></button>
        </div>

        <div class="auth-links">
          <a routerLink="/login" class="back-link">← Back to Login</a>
        </div>
      </form>

      <div class="app-buttons" style="display: flex; justify-content: center; align-items: center; gap: 20px; margin-top: 30px;">
        <a href="https://apps.apple.com/us/app/wowcare/id6630378434" target="_blank" rel="noopener noreferrer">
          <img src="assets/layout/images/appstoreplay.png" alt="App Store" class="app-button" style="height: 3rem; cursor: pointer; transition: transform 0.2s ease;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.wiseowlworld.schoolerpwowapp" target="_blank" rel="noopener noreferrer">
          <img src="assets/layout/images/googleplay.jpg" alt="Google Play" class="app-button" style="height: 3rem; cursor: pointer; transition: transform 0.2s ease;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
        </a>
      </div>
    </div>
  </div>
</div>